import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { ClientTablee } from './ClientTablee';
import { ShowClientsActions } from './ShowClientsActions';
import { ReciveSalesToLeed } from './ReciveSalesToLeed';
import { ClientHook } from '../Hook Code/ClientHook';
import ReplyIcon from '@mui/icons-material/Reply';
import {
  Autocomplete,
  Badge,
  Box,
  CircularProgress,
  createFilterOptions,
  Skeleton,
  TextField,
  Tooltip,
} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import XLSX from '../utils/excelUtils';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CloseIcon from '@mui/icons-material/Close';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { DeleteUserAction, GetAllLeadsSearchAction } from '../Redux/Actions/UsersAction';
import { useDispatch, useSelector } from 'react-redux';
// import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { Col, Row } from 'react-bootstrap';
import IconButton from '@mui/material/IconButton';

import moment from 'moment-timezone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { CountrySelect } from 'react-country-state-city';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CheckIcon from '@mui/icons-material/Check';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Notify } from '../Utility/Notify';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Pagination } from '../Utility/Pagination';
import { ShowAllCommentsForoneuser } from './ShowAllCommentsForoneuser';
import { db_url } from '../Api/BaseUrl';

export const Clients = () => {
  const [usersarray, allleads, loading, pagecount, getpages] = ClientHook();

  // get all inforamtaion about user logged

  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  // console.log(userlogin,"user will user in")

  // ===============================
  let limit = 50;

  const [show, setShow] = useState(false);
  const [showmoredelete, setshowmoredelete] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  // ===========================================
  const handleClosemoredelete = () => {
    setshowmoredelete(false);
  };
  const handleShowmoredelete = () => {
    setshowmoredelete(true);
  };

  //clipboard copy channal id
  const [open, setOpen] = useState(false);
  const handleCopy = () => {
    setOpen(true); // عرض رسالة تأكيد عند النسخ
    setTimeout(() => setOpen(false), 2000); // إخفاء الرسالة بعد 2 ثانية
  };

  // Export Data To Excell
  const exportToExcel = () => {
    // تحويل البيانات إلى صيغة Excel
    const ws = XLSX.utils.json_to_sheet(allleads);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Leads Data');

    // حفظ الملف
    XLSX.writeFile(wb, 'data.xlsx');
  };

  //import data from excel sheet to database
  //  import data from excel sheet to database

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [loadingimport, setloadingimport] = useState(false);
  const [fileName, setFileName] = useState('No file chosen'); // حالة لتخزين اسم الملف

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);

    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : 'No file chosen'); // تعيين اسم الملف
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage('Please select a file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setloadingimport(true);
      setMessage(''); // Clear any previous messages

      // إرسال الملف إلى الخادم عبر API
      // const response = await axios.post("https://apirender8.onrender.com/api/v1/users/import", formData, {
      const response = await axios.post(`${db_url}api/v1/users/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setloadingimport(false);
      setMessage('Leads imported successfully!');
      // console.log(response.data);
    } catch (error) {
      setloadingimport(false);
      setMessage('Error importing Leads: ' + error.response?.data?.message || error.message);
      console.error(error);
    }
  };

  const dispatch = useDispatch();
  //========================================
  // all leads

  const getallleads = async () => {
    await dispatch(GetAllLeadsSearchAction(`limit=${limit}`));
  };

  // دالة استخراج الدولة من الرقم
  countries.registerLocale(en); // تسجيل اللغة الإنجليزية

  const getCountryFromPhone = (phone) => {
    if (!phone || typeof phone !== 'string') return 'Unknown Country'; // ✅ التحقق من صحة المدخلات

    const phoneNumber = parsePhoneNumberFromString(phone.toString());

    if (!phoneNumber) return 'Unknown Country';

    const countryCode = phoneNumber.country; // مثال: AE أو EG
    const countryName = countries.getName(countryCode, 'en'); // جلب اسم الدولة بالكامل

    return countryName || 'Unknown Country';
  };

  // =========================================================assign lead
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [selectedLeadsforupdateanddelete, setselectedLeadsforupdateanddelete] = useState(null);

  const handleLeadSelection = (leadId) => {
    setSelectedLeads((prevSelectedLeads) => {
      if (prevSelectedLeads.includes(leadId)) {
        return prevSelectedLeads.filter((id) => id !== leadId);
      } else {
        return [...prevSelectedLeads, leadId];
      }
    });
    setselectedLeadsforupdateanddelete(leadId);
  };

  useEffect(() => {
    localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads));
  }, [selectedLeads]);

  // ========================================================
  // assign form
  const [openassign, setOpenassign] = React.useState(false);

  const handleClick = () => {
    setOpenassign(true);
  };

  const handleCloseassign = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenassign(false);
  };

  // ==============================

  // search filtiration
  const [budget, setbudget] = useState(null);
  const [country, setCountry] = useState(null);

  // budget change
  const budgetchaneg = (e) => {
    setbudget(e.target.value);
  };
  // creation date
  const [value, setValue] = useState(null);
  // =====================================
  const handleDateChange = (newValue) => {
    if (newValue) {
      // التنسيق ليظهر التاريخ فقط بدون الوقت
      const formattedDate = newValue.format('YYYY-MM-DD');
      setValue(formattedDate); // تخزين التاريخ بالتنسيق المناسب
    } else {
      setValue(null); // إذا كانت القيمة فارغة
    }
  };

  // ====================================

  // action date
  const [ValueActionDate, setValueActionDate] = useState(null);
  // =====================================
  const handlevalueactionDateChange = (newValue) => {
    if (newValue) {
      // التنسيق ليظهر التاريخ فقط بدون الوقت
      const formattedDate = newValue.format('YYYY-MM-DD');
      setValueActionDate(formattedDate); // تخزين التاريخ بالتنسيق المناسب
    } else {
      setValueActionDate(null); // إذا كانت القيمة فارغة
    }
  };
  // =======================================================
  // sales filteration
  const [selectedSale, setSelectedSale] = useState(null);

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
  });

  const handleChange_sales_filteration = (event, newValue) => {
    // هنا يتم تحديد القيمة التي تم اختيارها
    setSelectedSale(newValue); // `newValue` هي القيمة المختارة
  };

  const getsales = async () => {
    await dispatch(Get_All_Sales_Action());
  };

  const ressales = useSelector((state) => state.AllSales.sales);
  let salesarray = Array.isArray(ressales?.data) ? ressales.data : [];

  // =========================================
  // channel filteration
  const [selectedSalechannel, setSelectedSalechannel] = useState(null);

  const filterOptionschannel = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
  });

  const handleChange_channel_filteration = (event, newValue) => {
    // هنا يتم تحديد القيمة التي تم اختيارها
    setSelectedSalechannel(newValue); // `newValue` هي القيمة المختارة
  };

  const getchannels = async () => {
    await dispatch(GetAllchannalData());
  };

  const reschannel = useSelector((state) => state.AllChannalRoot.channal);
  let channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];

  // =================================================================

  // stage date filteration
  //
  const [stagedatevalue, setstagedatevalue] = useState(null);
  // =====================================
  const handlestageDateChange = (newValue) => {
    if (newValue) {
      // التنسيق ليظهر التاريخ فقط بدون الوقت
      const formattedDate = newValue.format('YYYY-MM-DD');
      setstagedatevalue(formattedDate); // تخزين التاريخ بالتنسيق المناسب
    } else {
      setstagedatevalue(null); // إذا كانت القيمة فارغة
    }
  };

  // ===================================
  // project filteration
  const [selectedproject, setSelectedprojetc] = useState(null);

  const filterOptionsproject = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
  });

  const handleChange_project_filteration = (event, newValue) => {
    // هنا يتم تحديد القيمة التي تم اختيارها
    setSelectedprojetc(newValue); // `newValue` هي القيمة المختارة
  };

  const getproject = async () => {
    await dispatch(GetallProjectsdata());
  };

  const resproject = useSelector((state) => state.AllProjects.Projects);
  let projectarray = Array.isArray(resproject?.data) ? resproject.data : [];

  // =========================================================

  // cancel reasons filteration
  //  const [selectedcancelreason, setselectedcancelreason] = useState(null);

  //  const filtercancelreason_cancelreason = createFilterOptions({
  //     matchFrom: 'start',
  //     stringify: (option) => option.name,
  //   });

  //   const handleChange_cancel_reason_filteration = (event, newValue) => {
  //     // هنا يتم تحديد القيمة التي تم اختيارها
  //     setselectedcancelreason(newValue); // `newValue` هي القيمة المختارة
  //   };

  // const getcancel_reason=async()=>{
  //   await dispatch(GetAll_CancelReasons_Data())
  // }

  // const res_cancel_reason=useSelector(state=>state.AllCancelReasons.Cancelreason)
  // let cancel_reason_array = Array.isArray(res_cancel_reason?.data) ? res_cancel_reason.data : [];

  // ====================================================================================
  // stages Data
  const [selected_stages, setselected_stages] = useState(null);

  const filter_stages_data = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
  });

  const handleChange_stages_data_filteration = (event, newValue) => {
    // هنا يتم تحديد القيمة التي تم اختيارها
    setselected_stages(newValue); // `newValue` هي القيمة المختارة
  };

  const get_stages_data = async () => {
    await dispatch(GetAll_stage_Data());
  };

  const res_stages_data = useSelector((state) => state.Allstages.stage);
  let stages_data_array = Array.isArray(res_stages_data?.data) ? res_stages_data.data : [];

  useEffect(() => {
    // getcancel_reason()
    getproject();
    getchannels();
    getsales();
    get_stages_data();
  }, []);

  // search quary
  // =================================================================
  // ==================================================
  // ==================================================
  // ======================================================
  let query = `limit=${limit}`;

  // إذا كانت الدولة موجودة، أضفها إلى الاستعلام
  if (country && country.phone_code) {
    query += `&phone=${country.phone_code}`;
  }

  // إذا كانت الميزانية موجودة، أضفها إلى الاستعلام
  if (budget) {
    query += `&budget=${budget}`;
  }

  // إذا كان اليوم فقط (dayonly) موجود، أضفه إلى الاستعلام
  if (value) {
    query += `&dayonly=${value}`;
  }

  if (selectedproject) {
    query += `&project=${selectedproject._id}`;
  }

  if (selectedSale) {
    query += `&sales=${selectedSale._id}`;
  }
  if (selectedSalechannel) {
    query += `&chanel=${selectedSalechannel._id}`;
  }

  if (selected_stages) {
    query += `&stage=${selected_stages.name}`;
  }
  // note
  // action date and stage date its the same search
  if (stagedatevalue) {
    query += `&last_stage_date_updated=${stagedatevalue}`;
  }
  if (ValueActionDate) {
    query += `&last_stage_date_updated=${ValueActionDate}`;
  }

  const handlesearchsubmit = async () => {
    await dispatch(GetAllLeadsSearchAction(query));
  };

  //  console.log(userlogin,"ffff")
  const handledeleteallselectedleads = async () => {
    const deletePromises = selectedLeads.map((leadId) => dispatch(DeleteUserAction(leadId)));

    await Promise.all(deletePromises);

    Notify('success', 'Leads deleted successfully', 'success');

    setTimeout(() => {
      window.location.reload(false);
    }, 1500);
  };

  // ==================================================
  // ==================================================
  const today = moment().startOf('day');
  const stagedate = moment(usersarray.stagedateupdated).startOf('day');

  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع الحالي (dark / light)
  //========================================================

  const action = (
    <React.Fragment>
      {/* assign lead to sales */}
      <Link
        to={`/assignleed`}
        style={{ height: '100%', textDecoration: 'none', color: 'white' }}
        className="mx-2"
      >
        <Button
          style={{ background: '#0F7687', border: 'none' }}
          size="small"
          onClick={handleCloseassign}
        >
          <ReplyIcon />
        </Button>
      </Link>

      {/* update client */}
      <Link
        to={`/updateclient/${selectedLeadsforupdateanddelete}`}
        style={{ height: '100%', textDecoration: 'none', color: 'white' }}
      >
        <Button
          style={{ background: '#0F7687', border: 'none' }}
          size="small"
          onClick={handleCloseassign}
        >
          <BorderColorIcon />
        </Button>
      </Link>

      {/* delete client */}
      <Button
        style={{ background: '#0F7687', border: 'none' }}
        size="small"
        className="mx-2"
        onClick={handleShowmoredelete}
      >
        <DeleteOutlineIcon />
      </Button>

      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseassign}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div style={{ width: '100%' }} className="clientheader">
      <div>
        <Snackbar
          open={openassign}
          // autoHideDuration={6000}
          onClose={handleCloseassign}
          message="More Actions"
          action={action}
        />
      </div>
      {/* //=================================================== */}

      <div className="tablecontainer">
        {/* modal import data from excel sheet */}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header
            closeButton
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            <Modal.Title>Modal Upload Excel File</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            {' '}
            <h1>Upload Excel File</h1>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="d-flex justify-content-center" style={{ marginTop: '25px' }}>
                <label htmlFor="file-upload" className="choose-file-button">
                  <i className="fas fa-cloud-upload-alt"></i>
                  <ControlPointDuplicateIcon /> <span> </span>Choose File
                </label>
                <input
                  type="file"
                  id="file-upload"
                  name="file"
                  onChange={handleFileChange}
                  className="choose-file-button "
                />
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{fileName}</div>
              <hr />

              <div className="d-flex justify-content-between">
                <Button variant="primary" type="submit">
                  <ImportExportIcon /> Submit File
                </Button>

                <Button variant="secondary" onClick={handleClose}>
                  <CloseIcon /> Close
                </Button>
              </div>
            </form>
          </Modal.Body>

          <div className="d-flex justify-content-center flex-wrap">
            {message && <p>{message}</p>}
          </div>
        </Modal>

        {/* ====================================== */}
        {/* modal Delete More Lead in the same time  */}

        <Modal show={showmoredelete} onHide={handleClosemoredelete}>
          <Modal.Header closeButton>
            <Modal.Title>Delete All Selected Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {' '}
            <h1>Delete All Selected Leads</h1>
            <hr />
            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={handleClosemoredelete}>
                <CloseIcon /> Close
              </Button>

              <Button variant="primary" type="submit" onClick={handledeleteallselectedleads}>
                <DeleteOutlineIcon /> Delete All Selected Leads .
              </Button>
            </div>
          </Modal.Body>

          <div className="d-flex justify-content-center flex-wrap">
            {message && <p>{message}</p>}
          </div>
        </Modal>

        {/* search*/}

        {/* ================================================= */}
        <Row>
          <Col className="clientbodyadmin">
            <Link to={`/dashboard`} style={{ textDecoration: 'none', color: '#0F7687' }}>
              <span style={{ fontWeight: 'bold' }}>Dashboard</span>
            </Link>{' '}
            <KeyboardDoubleArrowRightIcon /> <span>All Leads</span>
            {userlogin && userlogin.data ? (
              userlogin.data.role !== 'Sales' ? (
                <div className="buttonsforclientcontainer my-3">
                  <div
                    style={{ border: 'none' }}
                    className=" btn btn-info icon-plus  leedimportandexportandadd "
                    onClick={getallleads}
                  >
                    <ClearAllIcon /> All Leads{' '}
                    <span
                      style={{ fontSize: '20px', fontWeight: 'bold' }}
                    >{`(${usersarray.length})`}</span>
                  </div>

                  <Link to={`/addclient`} className="w-100">
                    <div
                      style={{ border: 'none' }}
                      className=" btn btn-info icon-plus addnewclientbtn    leedimportandexportandadd mx-md-2"
                    >
                      <AddIcon /> Add New Lead
                    </div>
                  </Link>

                  <div
                    style={{ border: 'none' }}
                    className=" btn btn-info icon-plus  leedimportandexportandadd "
                    onClick={exportToExcel}
                  >
                    <SystemUpdateAltIcon /> Export Leads To Excel Sheet
                  </div>
                  <div
                    style={{ border: 'none' }}
                    className=" btn btn-info icon-plus  leedimportandexportandadd mx-md-2"
                    onClick={handleShow}
                  >
                    <ImportExportIcon /> Import Leads Data From Excel Sheet
                  </div>

                  <Link to={`/AllLeads`}>
                    <div
                      style={{ border: 'none' }}
                      className=" btn btn-info icon-plus  leedimportandexportandadd mx-md-2"
                    >
                      <ImportExportIcon /> All Leads
                    </div>
                  </Link>
                  {/* <div style={{border:'none'}} onClick={handleShow} className=' btn btn-info icon-plus   leedimportandexportandadd mx-2' ><ImportExportIcon/> Import Leads Data From Excel Sheet</div> */}
                </div>
              ) : null
            ) : null}
            {/* ====================================================== */}
            {/* more filtiration */}
            <hr />
            <div className="filter-container">
              {/* Budget */}
              <div className="filter-item">
                <TextField
                  value={budget}
                  onChange={budgetchaneg}
                  label="Budget"
                  variant="standard"
                  type="number"
                  fullWidth
                />
              </div>

              {/* Creation Date */}
              <div className="filter-item">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Creation Date"
                    value={value ? dayjs(value) : null}
                    onChange={handleDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            '& fieldset': {
                              border: '2px solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #1976d2',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: '#555',
                            fontSize: '16px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>

              {/* Action Date */}
              <div className="filter-item">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Action Date"
                    value={ValueActionDate ? dayjs(ValueActionDate) : null}
                    onChange={handlevalueactionDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            '& fieldset': {
                              border: '2px solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #1976d2',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: '#555',
                            fontSize: '16px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>

              {/* Stage Date */}
              <div className="filter-item">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Stage Date"
                    value={stagedatevalue ? dayjs(stagedatevalue) : null}
                    onChange={handlestageDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            backgroundColor: '#fff',
                            '& fieldset': {
                              border: '2px solid #ccc', // Border like Action Date
                            },
                            '&:hover fieldset': {
                              border: '2px solid #1976d2', // Hover border
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2', // Focused border
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: '#555',
                            fontSize: '16px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>

              {/* Sales Filter */}
              <div className="filter-item">
                <Autocomplete
                  options={salesarray}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filterOptions}
                  onChange={handleChange_sales_filteration}
                  renderInput={(params) => <TextField {...params} label="Choose Sales" fullWidth />}
                />
              </div>

              {/* Stages Data */}
              <div className="filter-item">
                <Autocomplete
                  options={stages_data_array}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filter_stages_data}
                  onChange={handleChange_stages_data_filteration}
                  renderInput={(params) => (
                    <TextField {...params} label="Choose Stages" fullWidth />
                  )}
                />
              </div>

              {/* Channel */}
              <div className="filter-item">
                <Autocomplete
                  options={channelarray}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filterOptionschannel}
                  onChange={handleChange_channel_filteration}
                  renderInput={(params) => (
                    <TextField {...params} label="Choose Channel" fullWidth />
                  )}
                />
              </div>

              {/* Project */}
              <div className="filter-item">
                <Autocomplete
                  options={projectarray}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filterOptionsproject}
                  onChange={handleChange_project_filteration}
                  renderInput={(params) => (
                    <TextField {...params} label="Choose Project" fullWidth />
                  )}
                />
              </div>

              {/* Developer */}
              <div className="filter-item">
                <Autocomplete
                  options={projectarray}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filterOptionsproject}
                  onChange={handleChange_project_filteration}
                  renderInput={(params) => (
                    <TextField {...params} label="Choose Developer" fullWidth />
                  )}
                />
              </div>

              {/* Added By */}
              <div className="filter-item">
                <Autocomplete
                  options={projectarray}
                  getOptionLabel={(option) => option.name}
                  filterOptions={filterOptionsproject}
                  onChange={handleChange_project_filteration}
                  renderInput={(params) => <TextField {...params} label="Added By" fullWidth />}
                />
              </div>

              {/* Country Code */}
              <div className="filter-item ">
                <div
                  style={{
                    color: mode === 'dark' ? '#000' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  }}
                >
                  <CountrySelect
                    containerClassName="form-group"
                    inputClassName=""
                    onChange={(_country) => setCountry(_country)}
                    placeHolder="Select Country"
                  />
                </div>
              </div>

              {/* Apply Filter Button */}
              <div className="filter-item">
                <div
                  className="button-5"
                  style={{
                    background: '#0F7687',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    width: '100%',
                    padding: '10px',
                  }}
                  onClick={handlesearchsubmit}
                >
                  Apply Filter <FilterAltIcon />
                </div>
              </div>
            </div>
            {/* ================================================== */}
            <hr />
            {/* ============================================================================table clients */}
            <div style={{ borderRadius: '5px', overflowX: 'auto' }}>
              <Box
                sx={{
                  marginTop: '20px',
                  textAlign: 'center',
                  width: '100%',
                  backgroundColor: (theme) => theme.palette.background.paper,
                  color: (theme) => theme.palette.text.primary,
                  padding: '10px',
                  borderRadius: '10px',
                  overflowX: 'auto',
                  '& thead': {
                    backgroundColor: (theme) => theme.palette.primary.main,
                    color: '#fff',
                  },
                }}
              >
                <Table
                  size="small"
                  style={{
                    marginTop: '20px',
                    textAlign: 'center',
                    width: '100%',
                    color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                    minWidth: '800px',
                  }}
                  className={`tablee ${mode === 'dark' ? 'table-dark' : 'table-light'}`}
                >
                  <thead
                    style={{
                      borderRadius: '10px',
                      backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                      color: mode === 'dark' ? '#90caf9' : '#0F7687',
                    }}
                  >
                    <tr style={{ whiteSpace: 'nowrap' }}>
                      <th>
                        <div></div>
                      </th>
                      <th>Copy Id</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Project</th>
                      <th>Sales</th>
                      <th>Channel</th>
                      {userlogin && userlogin.data && userlogin.data.role !== 'Admin' && (
                        <th>Sales Rec</th>
                      )}
                      <th>Stage</th>
                      <th>Date</th>
                      <th>Added By</th>
                      <th style={{ color: 'white', textAlign: 'center' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={13} style={{ textAlign: 'center' }}>
                          <CircularProgress />
                        </td>
                      </tr>
                    ) : usersarray && usersarray.length > 0 ? (
                      usersarray.map((user, index) => (
                        <tr
                          key={index}
                          style={{
                            cursor: 'pointer',
                            textAlign: 'center',
                            color: mode === 'dark' ? '#90caf9' : '#0F7687',
                            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                          }}
                        >
                          {userlogin && userlogin.data && userlogin.data.role !== 'Sales' && (
                            <td>
                              <input
                                value={user._id}
                                type="checkbox"
                                checked={selectedLeads.includes(user._id)}
                                onChange={() => handleLeadSelection(user._id)}
                                onClick={handleClick}
                              />
                            </td>
                          )}

                          <td>
                            <CopyToClipboard onCopy={handleCopy}>
                              <div onClick={() => navigator.clipboard.writeText(user._id)}>
                                <ContentCopyIcon />
                              </div>
                            </CopyToClipboard>
                            <Snackbar open={open} autoHideDuration={2000}>
                              <Alert severity="success">Copy Done</Alert>
                            </Snackbar>
                          </td>

                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                            <div className="d-flex">
                              {user.name}
                              {userlogin &&
                              userlogin.data &&
                              userlogin.data.opencomments === false ? (
                                <ShowAllCommentsForoneuser user={user} />
                              ) : (
                                <ShowClientsActions user={user} />
                              )}
                            </div>
                          </td>

                          <td>{user.email || <Skeleton animation="wave" />}</td>

                          <td>
                            <div className="d-flex flex-column">
                              <div style={{ marginBottom: '5px' }}>{user.phone}</div>
                              <div style={{ color: '#666', fontSize: '12px' }}>
                                {getCountryFromPhone(`+${user.phone}`)}
                              </div>
                              <div className="d-flex justify-content-center mt-2">
                                <Tooltip title="اتصال هاتفي" placement="top">
                                  <IconButton
                                    size="small"
                                    onClick={() => window.open(`tel:${user.phone}`)}
                                    style={{ color: '#0F7687', marginRight: '8px' }}
                                  >
                                    <LocalPhoneIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="واتساب" placement="top">
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      window.open(`https://wa.me/${user.phone}`, '_blank')
                                    }
                                    style={{ color: '#25D366' }}
                                  >
                                    <WhatsAppIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </div>
                          </td>

                          <td style={{ textAlign: 'center' }}>{user.project?.name}</td>

                          <td
                            style={
                              user.assign ? { color: 'white', backgroundColor: '#0F7687' } : {}
                            }
                          >
                            {user.sales?.name || <Skeleton animation="wave" />}
                          </td>

                          <td>{user.chanel?.name}</td>

                          {userlogin && userlogin.data && userlogin.data.role !== 'Admin' && (
                            <td>
                              {user.assign === true ? (
                                <ReciveSalesToLeed user={user} />
                              ) : (
                                <div>assigned</div>
                              )}
                            </td>
                          )}

                          <td style={{ textAlign: 'center' }}>
                            <div>
                              {user.stage &&
                              user.stage.name !== 'Done Deal' &&
                              user.stage.name !== 'Fresh' ? (
                                <Badge
                                  style={{
                                    backgroundColor: moment(user.stagedateupdated)
                                      .startOf('day')
                                      .isBefore(today)
                                      ? '#CC5500'
                                      : 'royalblue',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    textAlign: 'center',
                                    color: 'white',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div style={{ textAlign: 'center' }}>
                                    {moment(user.stagedateupdated)
                                      .startOf('day')
                                      .isBefore(today) ? (
                                      <CloseIcon style={{ fontSize: 'medium' }} />
                                    ) : (
                                      <CheckIcon style={{ fontSize: 'medium' }} />
                                    )}
                                  </div>
                                </Badge>
                              ) : user.stage?.name === 'Fresh' ? (
                                <Badge badgeContent={`${'New'}`} color="success" />
                              ) : user.stage?.name === 'Done Deal' ? (
                                <div style={{ fontSize: '25px' }}>✌👏🎉🎉</div>
                              ) : null}
                            </div>
                            {user.stage?.name}
                            <br />
                            <div>
                              {user
                                ? moment(user.stagedateupdated).format('DD/MM/YYYY h:mm A')
                                : null}
                            </div>
                          </td>

                          <td>
                            {user
                              ? moment(user.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
                              : null}
                          </td>

                          <td>
                            User: {user.addby?.name}
                            <br />
                            Email: {user.addby?.email}
                            <br />
                            Role: {user.addby?.role}
                          </td>

                          {userlogin && userlogin.data && userlogin.data.role !== 'Sales' && (
                            <td
                              style={{
                                textAlign: 'center',
                                alignItems: 'center',
                                height: '100%',
                                borderRadius: '3px',
                                border: '2px solid #0F7686',
                              }}
                              className="d-flex justify-content-center flex-wrap"
                            >
                              <ClientTablee user={user} />
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={13}
                          style={{
                            textAlign: 'center',
                            padding: '40px',
                            fontSize: '18px',
                            color: mode === 'dark' ? '#90caf9' : '#0F7687',
                          }}
                        >
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Box>
              {usersarray && usersarray.length > 0 && (
                <Pagination pagecount={pagecount} onpress={getpages} />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
